/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, ErrorMessage } from "@";
import { useWatch } from "react-hook-form";
import CodeMirror from "@uiw/react-codemirror";
import { css } from "@codemirror/lang-css";

interface Props {
  control: any;
  setValue: any;
  errors: any;
  show?: string | undefined;
}

export const ThemeTemplateSection = ({
  control,
  setValue,
  errors,
  show,
}: Props) => {
  const themeContent =
    (useWatch({ control, name: "themeContent" }) as string) ?? "";
  const isDisabled = !!show;

  return (
    <Card star title="محرر الثيم">
      <p className="mb-3 text-xs text-gray-500 dark:text-gray-400">
        اكتب ثيم HTML + Liquid هنا. سيتم استخدام هذا الثيم لاحقاً عند ربطه بصفحة
        هبوط.
      </p>

      <div dir="ltr">
        <CodeMirror
        theme="none"
          maxHeight="80vh"
          minHeight="50vh"
          value={themeContent}
          readOnly={isDisabled}
          className="block w-full rounded-md border border-gray-300 bg-white font-mono text-sm leading-relaxed text-gray-800 focus-within:border-purple-500 focus-within:ring-1 focus-within:ring-purple-500 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
          extensions={[css()]}
          onChange={(value) =>
            setValue("themeContent", value, {
              shouldDirty: true,
              shouldValidate: true,
            })
          }
        />
      </div>

      <ErrorMessage value={errors?.themeContent?.message} />
    </Card>
  );
};
